import jsPDF from "jspdf";
import logoGente from "../../../src/imagens/20191205 - Logo GENTE.png";
import logoPrefeitura from "../../../src/imagens/prefeitura_ouro_preto_logo_1.png";
import Api from "../../services/Api";

class PdfInfra {
  static async gerarRelatorio(
    distrito,
    situacaoEstradas,
    manutencaoEstradas,
    infraMapImage,
    situacaoEstradasImage,
    manutencaoEstradasImage,
    infraImage,
  ) {
    const [
      propriedades,
      areaMedia,
      infraData,
      situacaoEstradasData,
      manutencaoEstradasData,
    ] = await Promise.all([
      Api.getNumeroPropriedadesInfra(
        distrito,
        situacaoEstradas,
        manutencaoEstradas,
      ),
      Api.getAreaMediaDistritoInfra(
        distrito,
        situacaoEstradas,
        manutencaoEstradas,
      ),
      Api.getInfraestrutura(distrito, situacaoEstradas, manutencaoEstradas),
      Api.getSituacaoEstradas(distrito, null, manutencaoEstradas),
      Api.getManutencaoEstradas(distrito, situacaoEstradas, null),
    ]);

    const doc = new jsPDF();
    const imgSize = 64;

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageOne(
      doc,
      distrito,
      propriedades.value,
      areaMedia.value,
      situacaoEstradas,
      manutencaoEstradas,
      infraMapImage,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageTwo(doc, infraData.value, infraImage);

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageThree(doc, propriedades.value, situacaoEstradasData.value, manutencaoEstradasData.value, situacaoEstradasImage, manutencaoEstradasImage, imgSize);

    const fileName =
      "Relatorio_Infraestrutura_" + distrito + "_" + this.dataAtual() + ".pdf";
    doc.save(fileName);
  }

  static pageOne(doc, distrito, propriedades, areaMedia, situacaoEstradas, manutencaoEstradas, infraMapImage) {
    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Considerações iniciais", 10, 40);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: "justify" });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);

    let y = 120;
    const filtros = [
      ["Distrito:", distrito || "Não informado"],
      ["Situação estradas:", situacaoEstradas || "Não informado"],
      ["Manutenção estradas:", manutencaoEstradas || "Não informado"],
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y += 5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [
      ["Propriedades:   ", propriedades],
      ["Área média:   ", areaMedia.toFixed(2)],
    ];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y += 5;

    doc.addImage(infraMapImage, "PNG", 20, y, 100, 80); // aumenta um pouco pra ver
  }

  static pageTwo(doc, infraData, infraImage) {
    let y = 40;

    doc.addImage(
      infraImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - 50,
      y,
      100,
      150,
    );

    y += 160;

    doc.text(
      `      A estrutura das propriedades demonstra grande diversidade de equipamentos e construções. A maioria das propriedades possui casa sede(${infraData["Casa Sede"]}), seguida por paiol (${infraData["Paiol"]}), estábulo/curral(${infraData["Estabulo/Curral"]}) e açude/represa (${infraData["Açude/Represa"]}). Também foram mencionados casa de trabalhador(${infraData["Casa de Trabalhador"]}), bomba(${infraData["Bomba"]}), picadeira(${infraData["Picadeira"]}) e galpão(${infraData["Galpão"]}). Equipamentos como trator(${infraData["Trator"]}), silagem(${infraData["Silagem"]}), carroça(${infraData["Carroça"]}), irrigação(${infraData["Irrigação"]}) e pulverizador (${infraData["Pulverizador"]}) aparecem com números menores. Infraestruturas mais específicas, como arado(${infraData["Arado"]}), ensiladeira (${infraData["Ensiladeira"]}), grade (${infraData["Grade"]}), desintegrador(${infraData["Desintegrador"]}), matraca(${infraData["Matraca"]}), plantadeira(${infraData["Plantadeira"]}), gerador(${infraData["Gerador"]}), silo/grãos(${infraData["Silo/Grãos"]}), colheitadeira(${infraData["Colheitadeira"]}), sulcador(${infraData["Sulcador"]}) e carro de boi(${infraData["Carro de boi"]}) são menos frequentes, indicando menor mecanização e dependência de estruturas básicas.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static pageThree(doc, propriedades, situacaoEstradasData, manutencaoEstradasData, situacaoEstradasImage, manutencaoEstradasImage, imgSize){
    let y = 40;

    doc.addImage(
      situacaoEstradasImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Constatou-se que ${this.calcPercentual(situacaoEstradasData["01 - Ruim"], propriedades)}% dos entrevistados classificaram as estradas como ruins, evidenciando insatisfação predominante quanto às condições de acesso. Já ${this.calcPercentual(situacaoEstradasData["02 - Bom"], propriedades)}% avaliaram a situação como boa, enquanto apenas ${this.calcPercentual(situacaoEstradasData["03 - Ótimo"], propriedades)}% consideraram as estradas em ótimo estado, indicando que melhorias na infraestrutura viária são uma demanda recorrente.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;

    doc.addImage(
      manutencaoEstradasImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Observou-se que ${this.calcPercentual(manutencaoEstradasData["01 - Não"], propriedades)}% dos produtores relataram não receber manutenção adequada nas estradas de acesso às propriedades. Em contrapartida, ${this.calcPercentual(manutencaoEstradasData["02 - Sim"], propriedades)}% informaram que sim, há algum nível de manutenção, embora ainda representem parcela menor dos participantes.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 5;
  }

  static calcPercentual(val, total) {
    const res = (val / total) * 100;
    return res.toFixed(2);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
    // Logo à esquerda
    if (logoEsq) {
      doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
    }

    // Logo à direita
    if (logoDir) {
      doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
    }

    // Título central
    doc.setFontSize(14);
    doc.text(
      "Relatório de infraestrutura das propriedades",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" },
    );
    doc.text(
      "rurais cadastradas no censo agropecuário",
      doc.internal.pageSize.getWidth() / 2,
      21,
      { align: "center" },
    );

    // Informações extras
    doc.setFontSize(8);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

    // Linha divisória
    doc.setDrawColor(150);
    doc.line(10, 32, 200, 32);
  }

  static dataAtual() {
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatada = data.replace(/\//g, "_");

    return formatada;
  }
}

export default PdfInfra;
